import Layout from '@/views/layout/Layout.vue'

export function generateRoutes(menuTree) {
  const staticFallbackPaths = [
    '/dashboard/index',
    '/learning/courses',
    '/learning/courses/edit',
    '/learning/courses/records'
  ]

  const dynamicRoutes = [{
    path: '/',
    component: Layout,
    children: []
  }]

  const parse = (nodes) => {
    nodes.forEach(node => {
      if ((node.type === 'menu' || node.type === 'page') && node.component) {
        if (staticFallbackPaths.includes(node.path)) {
          return
        }

        const cPath = node.component.replace(/^\//, '')
        dynamicRoutes[0].children.push({
          path: node.path,
          name: node.name,
          component: () => import(`@/views/${cPath}.vue`),
          meta: { title: node.display_name, icon: node.icon }
        })
      }

      if (node.children_tree) {
        parse(node.children_tree)
      }
    })
  }

  parse(menuTree)
  dynamicRoutes.push({ path: '*', redirect: '/404', hidden: true })
  return dynamicRoutes
}
